import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const appl17ValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    pastApp: yup
      .object()
      .shape({ m02_id: yup.string(), label: yup.string() })
      .nullable()
      .default(undefined)
      .transform((value, originalValue) => {
        if (
          originalValue &&
          typeof originalValue === "object" &&
          Object.keys(originalValue).length === 0
        ) {
          return undefined;
        }
        return value;
      }),
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    boardDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .required(t("Το πεδίο είναι υποχρεωτικό")),
    acceptedFinancialReport: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό")),
    fudocIsologismos: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    fudocPrakt: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    usageFromDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .max(
        new Date("2016-07-07"),
        t("Η ημερομηνία λήξης χρήσης δεν μπορεί να είναι μετά την 07/07/2016."),
      )
      .test(
        "is-before",
        t(
          "Η ημερομηνία 'Ισολογισμού Χρήσης Από' πρέπει να είναι πριν από την ημερομηνία 'Ισολογισμού Χρήσης Έως'.",
        ),
        function (value) {
          const { usageToDate } = this.parent;
          if (value && usageToDate && new Date(value) > new Date(usageToDate)) {
            return false;
          }
          return true;
        },
      ),
    usageToDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .max(
        new Date("2016-07-07"),
        t("Η ημερομηνία λήξης χρήσης δεν μπορεί να είναι μετά την 07/07/2016."),
      ),
  });
};
